<template>
  <main-page :user="user" color="blue">
    <template v-slot:title>
      <template>
        {{ prototype ? "VIEW PROTOTYPE" : "WATCH PITCH" }}
      </template>
    </template>

    <div class="sticky">
      <div class="video" :class="{ 'video-right': showFeedback }">
        <iframe
          v-if="pitch"
          class="video-embed"
          :src="pitch.video"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>

    <template v-slot:footer>
      <div class="col-6 text-right">
        <a class="btn btn-si-secondary mr-3" onclick="window.history.back()"> Back </a>
      </div>
    </template>
  </main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import PitchService from "@/services/PitchService";
import Notie from "@/services/NotieService";

export default {
  name: "PitchSubmission",

  props: ["user"],

  components: { MainPage },

  data() {
    var prototype = false;
    if (this.$route.path.includes("/prototype")) {
      prototype = true;
    }

    let pitchID = this.$route.params.pitchID;

    return {
      pitchID: pitchID,
      pitch: null,
      prototype: prototype,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      PitchService.getPitch(this.pitchID)
        .then((r) => {
          this.pitch = r.data;
        })
        .catch((e) => {
          console.log(e);
          Notie.error("Failed to load pitch", e);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  margin-bottom: 3rem;
  overflow:scroll;
}
.video {
  display: block;
  top: 0;
  margin-left: calc(50% - 640px);
  width: 1280px;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out;
}
.video-embed {
  width: 1280px;
  height: 720px;
  transition: height 0.5s ease-in-out, width 0.5s ease-in-out;
  border: 0;
}
</style>